"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
/**
 * MixerVideoEmbed.
 */
class MixerVideoEmbed extends react_1.default.Component {
    render() {
        const videoSrc = `https://mixer.com/embed/player/${this.props.channel}?disableLowLatency=1&showHosts=1`;
        return (react_1.default.createElement("div", { className: "mixer-video-embed embed-responsive embed-responsive-16by9" },
            react_1.default.createElement("span", { className: "mixer-video embed-responsive-item" },
                react_1.default.createElement("iframe", { allow: "autoplay; fullscreen", allowFullScreen: "true", title: this.props.title, src: videoSrc }))));
    }
}
exports.default = MixerVideoEmbed;
MixerVideoEmbed.propTypes = {
    channel: prop_types_1.default.string,
    title: prop_types_1.default.string
};
//# sourceMappingURL=MixerVideoEmbed.js.map